/*
 * Ex/inc VAT switch.
 *
 * The <html> class is set by an inline script in layout/theme.liquid, not
 * here, so the correct price is painted on the first frame. This file only
 * handles clicks and persistence, and is free to load late.
 *
 * Preference is per browser. It is never sent to Shopify and never affects
 * what is charged - see snippets/vat-toggle.liquid.
 */
(function () {
  var KEY = 'vatMode';

  function readMode() {
    return document.documentElement.classList.contains('vat-mode-inc') ? 'inc' : 'ex';
  }

  function applyMode(mode) {
    var root = document.documentElement;
    root.classList.toggle('vat-mode-inc', mode === 'inc');
    root.classList.toggle('vat-mode-ex', mode !== 'inc');

    // Private browsing and blocked site data both throw here. The class is
    // already applied by this point, so losing persistence costs the user a
    // re-click on the next page, not a wrong price.
    try {
      localStorage.setItem(KEY, mode);
    } catch (e) {
      /* no-op */
    }

    document.querySelectorAll('vat-toggle .vat-toggle__btn').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn.dataset.vatMode === mode));
    });

    document.dispatchEvent(new CustomEvent('vat:modechange', { detail: { mode: mode } }));
  }

  function onClick(event) {
    var btn = event.target.closest('.vat-toggle__btn');
    if (!btn || !btn.dataset.vatMode) return;
    applyMode(btn.dataset.vatMode);
  }

  document.addEventListener('click', onClick);

  // Sections re-rendered by the Section Rendering API (cart updates, variant
  // changes, quick-add) bring fresh buttons whose aria-pressed is whatever
  // Liquid emitted. Re-sync them against the mode actually in force.
  document.addEventListener('shopify:section:load', function () {
    applyMode(readMode());
  });

  applyMode(readMode());
})();
